import { EnterpriseModel } from './../management/enterprise.model';
import { ClientModel } from 'src/app/models/archive/client.model';
import { NoteOperatorEnums } from './../../enum/note-operator-enums';
import { NoteTypeEnums } from './../../enum/note-type-enums';
import { CostCenterModel } from 'src/app/models/archive/cost-center.model';
import { NoteStateEnums } from './../../enum/note-state-enums';
import { InvoiceModel } from './invoice.model';
import { DocumentSupportModel } from '../shopping/document-support.model';

export class NoteModel {
  noteId: number = 0;
  branchId: number = 0;
  enterpriseId: number = 0;
  enterprise: EnterpriseModel = new EnterpriseModel();
  bussinessDocumentsTypeId: number = 0;
  bussinessDocumentsResolutionId: number = 0;
  documentSupportId: number | null = 0;
  documentSupport: DocumentSupportModel | null = null;
  providerId: number | null = 0;
  noteTypeId: number = NoteTypeEnums.creditNote;
  operator: number = NoteOperatorEnums.credit;
  consecutive: number = 0;
  isLevelArticle: boolean = false;
  dateNote: Date = new Date;
  rentalPeriodId: number = 0;
  conceptId: number = 0;
  noteStateId: number = NoteStateEnums.open;
  accountingInterfaceId: number | null = null;
  electronicInvoiceInterfaceId: number | null = null;
  invoiceId: number | null = 0;
  invoice: InvoiceModel | null = null;
  clientId: number | null = 0;
  client: ClientModel | null = new ClientModel();
  costCenterId: number | null = null;
  costCenter: CostCenterModel | null = null;
  observationPrint: string | null = null;
  observation: string | null = null;
  cude: string | null = null;
  ivaTypeId: number = 0;
  administrationRate: number = 0;
  incidentalRate: number = 0;
  utilityRate: number = 0;
  subtotalValue: number = 0;
  ivaValue: number = 0;
  totalValue: number = 0;
  reteIvaRate: number = 0;
  reteIvaValue: number = 0;
  reteFuenteValue: number = 0;
  reteIcaValue: number = 0;
  valueToPay: number = 0;
  dateNotePdf: Date = new Date;
  dateNoteEmail: Date = new Date;
  dateNoteResend: Date = new Date;
  statusAcuse: number = 0;
  responseAcuse: string | null = null;
  responseEmailAcuse: string | null = null;
  operationTypeDian: number | null = 0;
  validationDian: number | null = null;
  dateValidationDian: Date = new Date;
  statusDianCode: string | null = null;
  statusDianDescription: string | null = null;
  technologicalProviderMessageCode: string | null = null;
  technologicalProviderMessageDescription: string | null = null;
  xmlName: string | null = null;
  clientStatusCode: string | null = null;
  swAttachments: boolean = false;
  isDocumentSupport: boolean;
  requestConsecutive: number = 0;
  requestNoteStateId: number = NoteStateEnums.open;
  elaborate: string | null = null;
  authorize: string | null = null;
  revise: string | null = null;
  approve: string | null = null;
  isRequest: boolean = false;
  createDate: string = "";
  userNameCreate: string = "";
  updateDate: string | null = null;
  userNameUpdate: string | null = null;

  //variable para controlar si están limpiando el formulario:
  clearForm: boolean = true;
}
